module.exports = __webpack_public_path__ + "img/material-default.d57cb9c3.png";